import React from 'react';
import { Box, Link } from '@chakra-ui/react';
import { Navigation } from '../Navigation';

function Header() {
  return (
    <Box
      as='header'
      zIndex='10'
      bg='white'
      color='black'
      borderBottom={1}
      borderStyle='solid'
      borderColor='gray.200'
    >
      <Link
        variant='buttonInverse'
        href='#main'
        className='skip-link'
        position='fixed'
        top={20}
        left={20}
        zIndex='2'
        transform='translateY(-200%)'
        transition='transform 0.2s ease-in-out'
        textTransform='uppercase'
        fontSize='sm'
        _focus={{
          transform: 'translateY(0)',
        }}
      >
        Skip to main content
      </Link>
      <Navigation />
    </Box>
  );
}

export default Header;
